import { useReducer } from 'react';

import { useCookies } from 'react-cookie';

import { ProviderState } from 'app/components/types';
import mainReducer from 'app/containers/Main/mainReducer';
import { providerSuggestEndpoint, signUp, stateSuggestEndpoint } from 'services/endpoints';
import getProviderEnv from 'utils/getProviderEnv';

export const invalidNPIForCreateProvider = 99999999999999999;

function useMainDataManager() {
  const [
    { formStep, confirmedProvider, loading, options, states, email, password, hasErrored, error },
    dispatch,
  ] = useReducer(mainReducer, {
    formStep: 1,
    confirmedProvider: null,
    loading: false,
    options: [],
    states: [],
    email: '',
    password: '',
    hasErrored: false,
    error: '',
  });

  const [cookies, setCookie] = useCookies(['accountId', 'accountType', 'impersonateFlag']);

  const NoProviders = {
    npi_id: invalidNPIForCreateProvider,
    prefix: '',
    title: '',
    provider_id: 0,
    last_name: '',
    provider_name: "I can't find my profile.",
    middle_name: '',
    first_name: '',
    photo_path: '',
    real_photo_path: '',
    state_abbreviation: '',
    sub_specialty_name: '',
    specialty_name: '',
    gender: 'M',
    address: '',
    city_name: '',
    primary_location: 0,
    suffix: '',
    zipcode: '',
  };

  function setStep(stepNumber) {
    dispatch({ type: 'updateFormStep', data: stepNumber });
  }
  function setConfirmedProvider(selectedProvider) {
    dispatch({ type: 'updateSelectedProvider', data: selectedProvider });
  }
  function setSearchRequest(searchValue: string, state?: string) {
    (async () => {
      try {
        dispatch({ type: 'searchRequest' });
        let url = `${providerSuggestEndpoint}?search=${searchValue}`;
        if (state) {
          url += `&state=${state}`;
        }
        const response = await fetch(url);
        const providers = await response.json();
        const { data } = providers;

        // the data oddly enough comes as an object instead of an array, so we need to convert it.
        const newArrayDataOfObject: ProviderState[] = Object.values(data);
        setSearchSuccess(newArrayDataOfObject);
      } catch (e) {
        dispatch({ type: 'errored', error: e });
      }
    })();
  }
  function setStateRequest() {
    (async () => {
      try {
        dispatch({ type: 'searchStateRequest' });
        let url = `${stateSuggestEndpoint}`;
        const response = await fetch(url);
        const states = await response.json();
        const { data } = states;

        // the data oddly enough comes as an object instead of an array, so we need to convert it.
        setSearchStateSuccess(data);
      } catch (e) {
        dispatch({ type: 'errored', error: e });
      }
    })();
  }
  function submitForm(data) {
    (async () => {
      try {
        dispatch({ type: 'submitRequest' });
        const response: any = await fetch(`${signUp}`, {
          method: 'post',
          body: JSON.stringify(data),
        });
        const parsedResponse = await response.json();
        if (parsedResponse.success) {
          dispatch({ type: 'submitSuccess' });

          setCookie('accountId', parsedResponse.data.account_id, {
            path: '/',
            domain: 'doctor.com',
          });
          setCookie('accountType', parsedResponse.data.account_type_id, {
            path: '/',
            domain: 'doctor.com',
          });
          setCookie('impersonateFlag', false, { path: '/', domain: 'doctor.com' });
          setCookie('token', parsedResponse.data.token, { path: '/', domain: 'doctor.com' });

          // post message so that iFrame parent can redirect to PADM
          try {
            window.parent.postMessage({ func: 'redirect' }, '*');
          } catch (_) {}

        } else {
          dispatch({ type: 'errored', error: parsedResponse.error});
        }
      } catch (e) {
        if(typeof e !== 'string') {
          e = e.toString();
        }
        dispatch({ type: 'errored', error: e });
      }
    })();
  }
  function setSearchSuccess(options) {
    //we add the Create Provider option
    const newOptions = [...options, NoProviders];
    dispatch({ type: 'searchSuccess', data: newOptions });
  }
  function setSearchStateSuccess(options) {
    dispatch({ type: 'searchStateSuccess', data: options });
  }
  function setStateEmail(email) {
    dispatch({ type: 'setStateEmail', data: email });
  }
  function setStatePassword(password) {
    dispatch({ type: 'setStatePassword', data: password });
  }
  function resetError() {
    dispatch({ type: 'resetError', data: password });
  }
  return {
    formStep,
    confirmedProvider,
    loading,
    options,
    states,
    email,
    password,
    hasErrored,
    error,
    setStep,
    setConfirmedProvider,
    setStateRequest,
    setSearchStateSuccess,
    setSearchRequest,
    setSearchSuccess,
    setStateEmail,
    setStatePassword,
    submitForm,
    resetError,
  };
}
export default useMainDataManager;
